<!--
 * @Author: your name
 * @Date: 2020-08-12 15:17:36
 * @LastEditTime: 2022-12-07 10:04:06
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/VenueIndex.vue
-->
<style scoped lang="sass">
.app_container
  display: flex
  flex-direction: column

  ::v-deep
    .van-sticky--fixed
      top: 58px

    .van-tabs__wrap
      box-shadow: 0px 2px 6px rgba(51,68,85,0.08)

  .banner
    width: 100%
    // height: 141px
    // object-fit: cover

  .item_list
    padding: 0 15px
  .special_category
    display: flex
    flex-wrap: nowrap
    overflow-x: scroll
    scrollbar-width: none
    margin-bottom: 10PX
    margin-left: 15PX

.total
  font-size: 15px
  color: var(--menu-primary-text-colour)
  text-align: center

  .price
    font-weight: bold
</style>

<style lang="sass" scoped>
.category_tabs
  ::v-deep
    .van-tabs__nav
      margin-left: 45px
      margin-right: 20px

    .van-tabs__content
      margin-top: 14px

    .van-tab__pane
      margin-top: -48px
      padding-top: 48px

.no_products
  margin: 40px 0
  width: 100%

.no_cate
  flex: 1
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column

  .no_category_text
    font-size: 14px
    margin-bottom: 30px
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    .change_time
      color: var(--menu-primary-background-colour) !important
      cursor: pointer

.icon
  height: 150px
  width: 150px

::v-deep
  .category_list
    .title
      margin-top: 5px
      border-bottom: 1px solid rgba(51, 68, 85, .1)
      padding-bottom: 8px
      .menu_time
        font-weight: normal
        font-size: 14px

    .category_list_section
      margin-top: 25px
      margin-bottom: 25px
      font-size: 18px
      max-height: 60vh
      overflow: auto
      .item
        min-height: 40px

  .allergy
    max-height: calc( 95vh - 70PX )

    .app_container
      padding: 31px 26px 26px 27px

  .van-tab--active
    color: var(--menu-primary-text-colour) !important
    border-bottom: 2px solid var(--menu-primary-background-colour) !important
    font-weight: bold !important
    opacity: 1 !important

  .van-tab
    color: var(--menu-primary-text-colour) !important
    font-weight: bold
    border-bottom: 2px solid transparent
    opacity: .5

  .van-tabs__line
    height: 0 !important
    // background-color: var(--menu-primary-background-colour) !important

  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .van-loading
    color: var(--menu-primary-background-colour) !important

.noPadding
  padding-bottom: 0 !important

.index1
  z-index: 1

</style>

<style lang="sass" scoped>
.view_menu
  font-size: 14px
  height: 54px

.title
  line-height: 30px
  margin-top: 35PX
  font-size: 25px
  color: var(--menu-primary-text-colour) !important

  &.margin_bottom
    margin-bottom: 50px

.next_open_time
  margin-top: 60PX
  margin-bottom: 78PX
  font-size: 13px
  color: var(--menu-primary-text-colour) !important

.opening_time_box
  display: flex
  align-items: center
  justify-content: center
  padding: 6px 0px
  background: #f4f3f5

  .opening_time_box_icon
    color: var(--menu-primary-text-colour) !important

  .item_box,
  .see_all_opening
    font-size: 12px
    line-height: 14px
    cursor: pointer

  .item_box
    margin-left: 6px
    font-weight: 500
    color: var(--menu-primary-text-colour)

  .see_all_opening
    margin-left: 10px
    font-weight: bold
    color: var(--menu-primary-background-colour) !important

.title_tabs_name
  margin-bottom: 12px
  padding: 0 15px
  font-size: 18px
  line-height: 22px
  text-align: center
  font-weight: bold
  color: #000
  letter-spacing: 0.8px
  text-transform: uppercase

.allergy_content
  width: 242px

  .allergy_text
    margin: 26px 0 21px 0
    text-align: center
    font-size: 15px
    color: #334455

  .allergy_img
    display: flex
    justify-content: center

    .img
      width: 57px

  .allergy_btn
    height: 56px
    font-size: 15px

</style>

<template lang="pug">
.app_container
  .overflow_scroll.index1(:class="{'noPadding': proList.length <= 0}")
    img.banner(:src="logo" ref="banner")
    .opening_time_box(v-if="isOnline")
      icon.opening_time_box_icon access_time_filled
      .item_box {{ setOpenItem }}
      .see_all_opening(@click="onSeeAllOpeningHours('showSeeAllOpeningHours')") {{ t('see_all_opening_hours', 'See all opening hours') }}
    van-tabs.category_tabs(
      v-show="productGroups.length > 0"
      v-model="activeIndex"
      :offsetTop="offsetTopHeight"
      swipeThreshold="2"
      sticky
      scrollspy
      @click="tabsChange"
      ref="tabsRow"
    )
      van-tab(
        v-if="listComputed(each.products).length > 0"
        line-width="100"
        :title="getLocalizedGroupName(each)"
        v-for="each in productGroups"
        :key="each.id"
        :disabled="each.disabled"
      )
        .title_tabs_name {{ getLocalizedGroupName(each) }}
        .special_category(v-if="each.products.length > 0 && each.details && each.details.special === true")
          SpecialCategoryItem.p(
            v-for="item in listComputed(each.products)"
            :key="item.id"
            :name="getLocalizedProductName(item)"
            :description="getLocalizedProductDesc(item)"
            :descriptionIsHtml="item.settings && item.settings.useHtmlDescription"
            :price="item.price"
            :tags="item.tags"
            :enablePopular="item.enablePopular"
            :quantity="item.num"
            :maskDisplay="!item.status"
            :imgUrl="getLocalizedProductImage(item)"
            :size-settings="item.sizeSettings"
            :hide-price="item.hidePriceInDesc ? item.hidePriceInDesc : false"
            :unavailableText="t('sold_out', 'Sold Out')"
            @choose="jumpToMenu(item.id, item.productGroupId, item.productGroupCourse, item)"
          )
        .item_list(v-if="each.products.length > 0 && (!each.details || each.details.special !== true)")
          dishes-list.p(
            v-for="item in listComputed(each.products)"
            :key="item.id"
            :name="getLocalizedProductName(item)"
            :description="getLocalizedProductDesc(item)"
            :descriptionIsHtml="item.settings && item.settings.useHtmlDescription"
            :price="item.price"
            :tags="item.tags"
            :enablePopular="item.enablePopular"
            :quantity="item.num"
            :maskDisplay="!item.status"
            :imgUrl="getLocalizedProductImage(item)"
            :size-settings="item.sizeSettings"
            :hide-price="item.hidePriceInDesc ? item.hidePriceInDesc : false"
            :unavailableText="t('sold_out', 'Sold Out')"
            @choose="jumpToMenu(item.id, item.productGroupId, item.productGroupCourse, item)"
          )
        .no_products(v-if="each.products.length === 0 && !showLoading")
          svg-icon(
            :color="color"
            icon-class="No_Products_No_Products_Icon"
          )
    .no_cate(v-if="(productGroups.length === 0 && !showLoading)")
      svg-icon.icon(
        :color="color"
        icon-class="No_Categories_No_Categories_Icon"
      )
      .no_category_text(v-if="isOnline")
        span {{ t('no_items_available', 'There are no items available at this time.') }}
        span.change_time(@click="$refs.deliverInfoDialog._show()") {{ t('change_time', 'Change time') }}
    terms-privacy(v-if="!showLoading" :showTermsDialog.sync="showTermsDialog" :showPrivacyDialog.sync="showPrivacyDialog")
  footer-bar.footer_bar_absolute(v-show="!isReadOnly && (proList.length > 0 || subGroupCartHasProduct)" :status="footerStatus" @clickButton="__checkVenueTodayIsOpenTime(jumpToCart)" :disabled="disableButton")
    template(v-slot:left)
      .total {{ t('order_total', 'Order total:') }}
        span.price.ls1 {{ symbolPosition === 'after' ? ' ' : ' ' + currencySymbol }}{{ cvt(total) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  mask-order-history(:showMask.sync="showOrderHistoryDialog")
  terms-dialog(:showTermsDialog.sync="showTermsDialog" v-if="showTermsDialog")
  privacy-dialog(:showPrivacyDialog.sync="showPrivacyDialog" v-if="showPrivacyDialog")
  bottom-popup-dialog(v-model="showCloseTimeDialog" @changeShow="closePopupDialog")
    template(v-slot:popup-dialog)
      .title.b.t_a_c(:class="{ 'margin_bottom' : isOnline }") {{ t('sorry_not_taking_orders', 'Sorry, we are not taking orders right now.') }}
      .next_open_time.b.t_a_c.o75(v-if="!isOnline") {{ nextVenueOpenTime }}
      van-button.view_menu.b.ls1(@click="closePopupDialog" type="primary" block) {{ t('view_our_menu_anyway', 'VIEW OUR MENU ANYWAY') }}
  mask-manage-tab(:showMask.sync="showManageTabDialog")
  delivery-info-dialog(
    ref="deliverInfoDialog"
    :isVenueCloseTime="!isOriginalVenueOpenTime"
    @showCloseTimeDialog="showCloseTimeDialog = true"
    @submit="deliveryGetData"
    @showDeliveryVisible="showDeliveryVisible"
  )
  seeAllOpeningHours(ref="showSeeAllOpeningHours" :weeklyOperatingHours="weeklyOperatingHoursSegmentation")
  readOnlyDialog(v-if="dineInSettings.viewOnlyMessage" :dineInSettings="dineInSettings")
  add-to-home-screen-prompt(v-if="enableAddToHomeScreen && !number" :enabled="enableAddToHomeScreen" :venue-id="venueId" :venue-name="venueName" :venue-logo="logo" :home-screen-name="homeScreenName" :table-number="number" :read-only="isReadOnly" :sp-mode="isSpMode" @a2hsExposure="trackA2hsExposure" @a2hsOutcome="trackA2hsOutcome" @a2hsDismiss="trackA2hsDismiss")
  bottom-popup-dialog.allergy(
    v-model="showAllergyDialog"
    position="center"
    :showCloseIcon="false"
    @changeShow="closeAllergyDialog"
  )
    template(v-slot:popup-dialog)
      .allergy_content
        .allergy_img
          img.img(:src="warningIcon")
        .allergy_text {{ allergyText }}
        van-button.allergy_btn.b.ls1(type="primary" block @click="closeAllergyDialog") {{ t('ok', 'OK') }}

  mask-category-list-button(:showMask.sync="showMaskCategoryListButton" bindQuerySelectorString="categoryListButtonIdBindContainer")
  bottom-popup-dialog.category_list(
    v-model="showCategoryListDialog"
    @changeShow="closeCategoryListDialog"
    :showCloseIcon="false"
  )
    template(v-slot:popup-dialog)
      .title.b.t_a_c() {{ t('menu', 'Menu') }}
        .item_box.menu_time {{ setOpenItem }}
      .category_list_section
        .item(v-for="(item, index) of productGroups")(:class="{ 'bold' : index === activeIndex }" @click="selectCategory(index, item)") {{ getLocalizedGroupName(item) }}
      van-button.view_menu.b.ls1(@click="closeCategoryListDialog" type="primary" block) {{ t('dismiss', 'DISMISS') }}
  upgrade-combo-dialog.upgrade_combo(
    v-model="showUpgradeComboDialog"
    :combo-products="upgradeProduct"
    :product-info="selectProductIdInfo"
    @confirm="redirectUpgradeCombo"
  )
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import { isAlcoholProduct } from '@/utils/alcohol'
import { productHasUnpickableRequiredSection } from '@/views/product-detail/utils/productDisplay'
import MaskOrderHistory from 'components/MaskOrderHistory'
import MaskCategoryListButton from 'components/MaskCategoryListButton'
import TermsPrivacy from './component/TermsPrivacy'
import TermsDialog from './component/TermsDialog'
import PrivacyDialog from './component/PrivacyDialog'
import DeliveryInfoDialog from 'components/DeliveryInfoDialog'
import CategoryListButton from './component/CategoryListButton'
import SpecialCategoryItem from './component/SpecialCategoryItem'
import UpgradeComboDialog from './component/UpgradeComboDialog'
import { getMenu, getProductList, getTableExtra, getUserOrders, getVenue } from '@/api/product'
import { _formatWeek, _getNowOperatingHours, _isOpenStatus, _isPassCustomHours, _weeklyOperatingHours, safeDecodeURI } from 'utils'
import dayjs from 'dayjs'
import { MessageDialog } from '@/plugins/createApi'
import failIcon from '@/assets/tab-pics/warning-icon.png'
import { customReadyTab, } from 'utils/message'
import { mapState, } from 'vuex'
import { _isIncludesMainNavigator } from '@/utils/navigator'
import MaskManageTab from 'components/MaskManageTab'
import seeAllOpeningHours from './component/SeeAllOpeningHours'
import readOnlyDialog from './component/readOnlyDialog'
import AddToHomeScreenPrompt from '@/components/AddToHomeScreen'
import resizeHandler from 'utils/resizeHandler'
import { trackQrScan } from 'utils/qrScanTracking'
import { trackFunnelEvent } from 'utils/funnelTracking'
import { shouldTrackA2hsOpenHere } from '@/utils/addToHomeScreen/attribution'
import { applyIosBookmarkMeta } from '@/utils/addToHomeScreen/iosBookmarkMeta'
import { getLocalizedCustomMessage, getLocalizedField, t, tParams } from '@/utils/language'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { isStoreVenue, menuContextFromState, resolvedMenuIdOf, withMenuId } from '@/utils/menu/qrMenu'
import { menuEntry } from '@/utils/menu/qrEntry'
import { isMenuGoneError, readWithMenuRetry } from '@/utils/menu/menuRead'
import { checkCartAgainstMenu } from '@/utils/menu/menuCheck'
import { menuChangedNoticeText } from '@/utils/menu/menuChanged'
import { isOrderingBlockedByPreview } from '@/utils/menu/previewOrderBlock'
import { createMessageDialog } from '@/utils/request/messageDialog'
import Vue from 'vue'

const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

@Component({
  filters: {
    fix(val) {
      return formatDecimalNumber(val)
    },
  },

  async mounted() {
    this._addDisabledJumpButton()
    this._getTime()
    this.$store.commit('showLoading')
    await this._postVenue()
    await this._filterAndSaveUnfinishOrder()
    this._getTableExtra()
    this._setupSubGroup()
    if (!this.alcoholButton && !this.isOnline) this._setAllergyDialog()
    // 获取 venueId，这是关键
    // if there is no venueId, the venueId doesn't exist.
    // disabled to send request
    if (this.venueId) await this.getData()

    // 获取 venueId 后，才能获取 activeIndex
    this._getActiveIndex()

    // 如果是从 QR 进入的，并且有 noImage 选项，则不显示任何图片，采用 placeholder 做处理
    if (this.fromQR) {
      if (this.$route.query.noImage === '1') {
        this.$store.commit('saveShowImage', false)
      } else {
        this.$store.commit('saveShowImage', true)
      }
    }

    // check has auto discount code
    if (this.$route.query.autoDiscountCode) {
      // console.log(this.$route.query.autoDiscountCode, atob(this.$route.query.autoDiscountCode))
      this.$store.commit('saveSpDiscountsCode', atob(this.$route.query.autoDiscountCode))
    }

    // noAlcohol:URL(noAlcohol=1 或 filterRule=noAlcohol)或子分组设置(subGroupSettings,跨 venue 存活)触发
    // 须在 _setupSubGroup() 之后(subGroupId 已设),且在 _postVenue() 的 resetState 之后,与 autoDiscount 同位置
    this.$store.commit('saveNoAlcohol', this._resolveNoAlcohol())

    this._setUrlType()

    // 用户 Id 存在并且是从 QR 进来的，请求接口并判断是否有 unOverOrder。如果有，则跳转到 pay 或者 my-order 页面
    if (this.userId && this.fromQR) {
      const res = await this._getUserUnOverOrders('notstart')
      const orderTotal = res.orders.length
      if (orderTotal >= 1) {
        for (let i = 0; i < parseInt(res.total); i++) {
          const hasUnfinishOrder = this._checkUnfinishOrder(res.orders[i])
          if (hasUnfinishOrder) break
        }
      }
    }
    if (!this.isReadOnly) this.showMask()
    this.saveData()

    if (this.venueId) {
      // if there is no venueId, the venueId doesn't exist.
      // disabled to operation DOM

      // 获取 session 中的 _getScrollPosition
      this.$nextTick(() => {
        if (this.isMobile) {
          this.getOffsetTopHeight()
          this._getScrollPosition()
        }
        this.$store.commit('closeLoading')
      })
    }
    this._sendMsgToBacken()
    this.checkShowCloseTimeDialog()
    this.checkShowClosePosDialog()
    this.getNextVenueOpenTime()
    this._openTabReadyDialog()
    this._openDeliveryInfoDialog()
    this._setupCategoryListButton()

    if (this.$openreplayTracker) this.$openreplayTracker.event('view_home')

    // QR 扫码入口统计（?qr=1）：venue 数据已加载，带上餐厅全名
    trackQrScan(this.$route, this.venueName)

    // 桌面图标回访统计（?src=home，每标签页会话一次）
    if (shouldTrackA2hsOpenHere()) trackFunnelEvent('a2hs_open')
  },

  mixins: [resizeHandler], // 判断是不是手机端的方法

  props: {
    number: {
      type: [String, Number],
      default: ''
    }
  },

  components: {
    MaskCategoryListButton,
    MaskOrderHistory,
    TermsPrivacy,
    TermsDialog,
    PrivacyDialog,
    MaskManageTab,
    DeliveryInfoDialog,
    seeAllOpeningHours,
    readOnlyDialog,
    UpgradeComboDialog,
    SpecialCategoryItem,
    AddToHomeScreenPrompt
  },

  computed: {
    ...mapState({
      isOnline: state => state.app.isOnline,
      venueUrlId: state => state.venueHome.urlId,
      venueGroupId: state => state.venueHome.venueGroupId,
      alcoholButton: state => state.venueHome.alcoholButton,
      currentVenueTime: state => state.app.currentVenueTime,
      currentLanguage: state => state.language.currentLanguage,
      currentCurrency: state => state.currencySettings?.currentCurrency,
    }),

    /**
     * @returns {Boolean} 当前是否是只读模式
     */
    isReadOnly() {
      // url 中带有 '/r/v/' 时，说明是只读模式
      return this.$route.path.includes('/r/v/')
    },

    /**
     * @returns {Boolean} 当前是否是 SP 模式
     */
    isSpMode() {
      // url 中带有 '/v/sp/' 或者路由 meta 中有 isSpMode 标记
      return this.$route.path.includes('/v/sp/') || this.$route.meta?.isSpMode === true
    },

    deliveryInfo () {
      return this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
    },

    subGroupCartHasProduct() {
      return this.$store.state.venueHome.subGroupId ? this.$store?.getters.subGroupCartHasProduct() : false
    },

    showLoading () {
      return this.$store.state.showLoading
    },
    proList() {
      return this.$store.state.productList.filter(item => item.venueId === this.venueId)
    },
    total() {
      if (this.$store.state.venueHome.subGroupId) {
        return this.$store.getters.subGroupCartTotal()
      } else {
        return this.$store.getters.total(this.venueId)
      }
    },
    color() {
      return this.$store.state.app.color.menu_primary_background_colour
    },
    userId() {
      return localStorage.getItem('userId')
    },
    fromQR() {
      const VERSION_SETTINGS = {
        OLD_VERSION: {
          VALUE: 'TRUE',
          SIGN: 'fromQR'
        },
        NEW_VERSION: {
          VALUE: '1',
          SIGN: 'qr'
        }
      }
      const isNewVersionFromQR = this.$route.query[VERSION_SETTINGS.NEW_VERSION.SIGN] === VERSION_SETTINGS.NEW_VERSION.VALUE
      const isOLdVersionFromQR = this.$route.query[VERSION_SETTINGS.OLD_VERSION.SIGN] === VERSION_SETTINGS.OLD_VERSION.VALUE
      return isNewVersionFromQR || isOLdVersionFromQR
    },
    footerStatus() {
      if (this.productGroups.length) {
        return (this.venueIsOpenTime || this.isOnline) ? 4 : 5
      } else {
        const showLoading = this.$store.state.showLoading
        return showLoading ? 4 : 5
      }
    },
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },
    disableButton() {
      if (this.productGroups.length) {
        return !(this.venueIsOpenTime || this.isOnline)
      } else {
        const showLoading = this.$store.state.showLoading
        return !showLoading
      }
    },

    // 餐厅营业时间
    setOpenItem() {
      // 当前是星期几
      const todayWeek = dayjs(this.currentVenueTime).format('dddd').toLowerCase()
      // 获取对应今天的对象
      const todayOpenTime = this.weeklyOperatingHours[todayWeek]
      if (!this.venueOperationTime.enable) return t('closed', 'Closed')
      // 如果 todayOpenTime 没有分段营业时间，就走老的营业时间
      if (!todayOpenTime?.hourSettings?.length) {
        if (this.venueOperationTime.fromHour && this.venueOperationTime.toHour) {
          const fromHour = this.venueOperationTime.fromHour
          const toHour = this.venueOperationTime.toHour
          return dayjs(`2020-10-10 ${fromHour}`).format('HH:mm') + ' - ' + (toHour === '24:00' ? toHour : dayjs(`2020-10-10 ${toHour}`).format('HH:mm'))
        }
      } else {
        const time = _weeklyOperatingHours(this.weeklyOperatingHours)
        const timeList = time.split('-')
        const fromTime = this._setTimeFormat(timeList[0].trim())
        const toTime = this._setTimeFormat(timeList[1].trim(), true)
        return `${fromTime} - ${toTime}`
      }
    },
  }
})

class VenueIndex extends mixins(mixin) {
  urlType = '' // 当前链接的类型 table、counter、takeaway、pickup、delivery
  warningIcon = require('@/assets/tab-pics/warning-icon.png')
  showManageTabDialog = false
  checkinJumpToUrl = ''
  posStatus = null

  // 「保存到桌面」按店开关，来自 venueInfo.settings.options.enableAddToHomeScreen
  enableAddToHomeScreen = false
  // 店家自配的桌面短名（venueInfo.homeScreenName），供 iOS 书签名字注入
  homeScreenName = ''
  enableCheckin = false
  disabledButton = false
  offsetTopHeight = 56
  nextVenueOpenTime = ''
  weeklyOperatingHours = {}
  showCloseTimeDialog = false
  // 是否显示过敏提示弹框
  showAllergyDialog = false
  showTermsDialog = false
  showPrivacyDialog = false
  venueId = ''
  venueIsOpenTime = null
  venueOperationTime = {}
  time = {}
  // defaultPaymentType = 'post-paid'
  // showSeeAllOpeningHours = false
  defaultPaymentType = 'pre-paid'
  logo = ''
  activeIndex = 0
  routerType = 1
  showOrderHistoryDialog = false
  productGroups = []
  freeItemId = ''
  venueName = this.$store.state.navTitle?.venueName ?? ''
  weeklyOperatingHoursSegmentation = {} // 餐厅分段营业时间
  dineInSettings = {} // 餐厅的 dine-in 设置
  customMessageSettings = {}
  spModeSettings = {} // SP 模式设置
  spTableList = [] // SP 模式下的桌号列表
  allergyText = ''

  showCategoryListDialog = false
  showMaskCategoryListButton = false
  showUpgradeComboDialog = false
  selectProductIdInfo = {}
  upgradeProduct = []

  // ==================== Localization Helpers / 本地化辅助方法 ====================

  /**
   * Get localized product group name / 获取本地化的产品分组名称
   */
  getLocalizedGroupName(group) {
    // eslint-disable-next-line no-unused-expressions
    this.currentLanguage
    return getLocalizedField(group, 'name') || group.name
  }

  /**
   * Get localized product name / 获取本地化的产品名称
   */
  getLocalizedProductName(product) {
    // eslint-disable-next-line no-unused-expressions
    this.currentLanguage
    return getLocalizedField(product, 'name') || product.name
  }

  /**
   * Get localized product description / 获取本地化的产品描述
   */
  getLocalizedProductDesc(product) {
    // eslint-disable-next-line no-unused-expressions
    this.currentLanguage
    return getLocalizedField(product, 'description') || product.description
  }

  /**
   * Get localized product image / 获取本地化的产品图片
   */
  getLocalizedProductImage(product) {
    // eslint-disable-next-line no-unused-expressions
    this.currentLanguage
    const localizedImage = getLocalizedField(product, 'image')
    return localizedImage || product.image
  }

  /**
   * Translation helper for templates / 模板翻译辅助
   */
  t(key, fallback) {
    // eslint-disable-next-line no-unused-expressions
    this.currentLanguage
    return t(key, fallback)
  }

  // ==================== 「保存到桌面」埋点 ====================
  // 曝光 / 结果（accepted、dismissed、unavailable）/ 拒绝，均带平台，
  // 阶段六以这三个事件 + a2hs_open 回访估算转化率
  trackA2hsExposure({ platform, browser, source }) {
    // source 区分入口：'auto' 自动弹窗 / 'menu' 抽屉菜单手动打开；
    // browser 是 Android Chromium 系的品牌维度（chrome/samsung/edge/...）
    trackFunnelEvent('a2hs_exposure', { platform, browser, source })
  }

  trackA2hsOutcome({ outcome, source, platform, browser }) {
    // platform+browser 区分 outcome=guide 走的是哪条引导路径
    trackFunnelEvent('a2hs_outcome', { outcome, source, platform, browser })
  }

  trackA2hsDismiss({ platform, browser, source }) {
    trackFunnelEvent('a2hs_dismiss', { platform, browser, source })
  }

  /**
   * Convert price to display currency / 转换价格到显示货币
   * References this.currentCurrency for Vue reactivity / 引用 this.currentCurrency 以实现 Vue 响应式
   */
  cvt(price) {
    // eslint-disable-next-line no-unused-vars
    const _currency = this.currentCurrency
    return convertPrice(price)
  }

  /**
   * 如果是 Delivery 不显示的情况，则酒精提示弹框开启
   * @param {Boolean} val Delivery 是否显示
   */
  showDeliveryVisible(val) {
    if (!val && this.isOnline && !this.alcoholButton) this._setAllergyDialog()
  }

  /**
   * 获取当前的链接类型，并给 urlType 赋值
   */
  _setUrlType() {
    let type = ''
    const { name, query, path } = this.$route
    const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
    // 根据当前环境，获取环境类型
    if (name === 'venue-home-table') {
      type = 'table'
    } else if (query.portal === 'true') {
      const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
      // dineInSettings - enableTakeaway，有值且为 false 时，不显示弹窗
      if (isTakeaway && 'ta' in query) {
        type = this.dineInSettings?.enableTakeaway === false ? '' : 'takeaway'
      } else {
        type = 'counter'
      }
    }
    if (this.isOnline && deliveryInfo?.orderType) {
      type = 'pickup'
      if (deliveryInfo.orderType === 'delivery') type = 'delivery'
    }
    console.log(type)
    this.urlType = type
  }

  /**
   * 时间格式转换由 12 小时转为 24 小时制度
   * @param time {String} 12 小时制度时间
   * @param isChange {Boolean} 是否将 00:00 转换成 24:00
   * @returns {String} 24 小时制度时间
   */
  _setTimeFormat(time, isChange = false) {
    const hour = Number(time.split(':')[0].replace(/[^\d]/g, ''))
    let min = time.split(':')[1]
    let type = ''

    if (min.indexOf('am') > 0) {
      type = 'am'
      min = min.replace('am', '')
    }

    if (min.indexOf('pm') > 0) {
      type = 'pm'
      min = min.replace('pm', '')
    }

    return type === 'am' ? (hour === 12 ? `${isChange ? hour + 12 : '00'}:${min}` : `${hour}:${min}`) : (hour === 12 ? `${hour}:${min}` : `${hour + 12}:${min}`)
  }

  // 获取 table 相关信息
  async _getTableExtra() {
    this.$store.commit('showLoading')
    const res = await getTableExtra({
      venueId: this.venueId,
      tableNo: this.number ?? ''
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.freeItemId = (res.noOfFreeItem - res.noOfUsedFreeItem <= 0) ? res.FreeItemId : ''
  }

  /**
   * 设置 allergyDialog 的文案信息，并且判断是否显示弹窗
   */
  _setAllergyDialog() {
    let text = ''
    if (this.customMessageSettings && !this._.isEmpty(this.customMessageSettings)) {
      this._setUrlType()
      // 根据当前环境，获取对应的弹窗设置的信息
      const popup = this.customMessageSettings?.popup
      // SP 模式下，使用 spMode 的 popup 消息
      const messageType = this.isSpMode ? 'spMode' : this.urlType
      const messageEntry = popup[messageType]
      const message = getLocalizedCustomMessage(messageEntry) ?? ''
      if (messageEntry?.enable && message.trim()) text = message
    }
    this.allergyText = text
    // 若文案为空，则不显示弹窗
    if (text) this.showAllergyDialog = true
  }

  // 判断是不是外卖地址，然后决定是否展示外卖地址相关的弹出层
  _openDeliveryInfoDialog() {
    const urlId = this.$route.params.venueId
    const isUrlId = urlId.indexOf(this.venueUrlId) >= 0

    if (this.isOnline && _isIncludesMainNavigator()) {
      if (isUrlId && this.$route.query.portal) {
        if (parseInt(this.total) <= 0 || !this.deliveryInfo?.orderType) this.$refs.deliverInfoDialog._show()
      } else {
        if (!this.deliveryInfo?.orderType) this.$refs.deliverInfoDialog._show()
      }
    }
  }

  _setupCategoryListButton() {
    // smion add specific rule for category list
    const container = this.$refs.tabsRow.$el.querySelector('.van-tabs__wrap')
    container.id = 'categoryListButtonIdBindContainer'
    const ComponentClass = Vue.extend(CategoryListButton)
    const instance = new ComponentClass({
      parent: this,
      propsData: {
        bindQuerySelectorString: container.id
      }
    })
    instance.$on('update:showCategoryListDialog', item => {
      this.showCategoryListDialog = true
    })
    instance.$mount()

    container.prepend(instance.$el)
    this.$once('hook:beforeDestroy', () => {
      instance.$destroy()
      container.removeChild(instance.$el)
    })

    // check mask need to show or not
    try {
      const mark = JSON.parse(localStorage.getItem('showMaskCategoryListButton') ?? '{}')
      const currentDate = new Date().toISOString().split('T')[0]
      if (mark && mark.date === currentDate) {
        // same day - only show once
        if (mark.value === 'unShow') {
          this.showMaskCategoryListButton = false
        } else this.showMaskCategoryListButton = true
      } else {
        this.showMaskCategoryListButton = true
      }
    } catch (e) {
      this.showMaskCategoryListButton = true
    }
  }

  _openTabReadyDialog() {
    const { isReadyTab } = this.$route.query
    if (isReadyTab) {
      const self = this
      this.$createTabMessageDialog({
        $props: customReadyTab,
        $events: {
          click() {
            self.showManageTabDialog = true
          }
        }
      }).show()
    }
  }

  _addDisabledJumpButton() {
    const self = this
    window.addEventListener('message', function(e) {
      if (e.data.name === 'isIframe') {
        self.disabledButton = true
      }
    })
  }

  reload() {
    this.$parent.reload() // 调用父组件的 reload 方法
  }

  // 主页提交到购物车页面
  async __checkVenueTodayIsOpenTime(fun) {
    if (this.disabledButton) return

    this.$store.commit('showLoading')
    const isOpen = await this.__checkVenueOpenTime() // mixin 是否在开放时间的方法
    if (isOpen) {
      fun()
    } else {
      this.reload()
      this.$store.commit('closeLoading')
    }
  }

  // nav_bar 的吸顶高度
  getOffsetTopHeight() {
    const height = document.getElementsByClassName('nav_bar')[0].offsetHeight ?? 0
    this.offsetTopHeight = height
  }

  closePopupDialog() {
    this.showCloseTimeDialog = false
    this._setTodayTime()
  }

  // 关闭过敏提示框
  closeAllergyDialog() {
    this.showAllergyDialog = false
    this.$store.commit('saveAlcoholButton', true)
  }

  selectCategory(index, item) {
    this.showCategoryListDialog = false
    this.activeIndex = index
    const tabsRowE = this.$refs.tabsRow
    tabsRowE.$nextTick(function () {
      const duration = tabsRowE.duration
      tabsRowE.setCurrentIndexByName(index)
      tabsRowE.duration = 0.8
      tabsRowE.scrollToCurrentContent()
      tabsRowE.duration = duration
    })
    // this.$refs.tabsRow.scrollTo(this.activeIndex)
  }

  closeCategoryListDialog() {
    this.showCategoryListDialog = false
  }

  _setTodayTime() {
    const nowTime = dayjs(this.currentVenueTime).format('YYYY-MM-DD')
    this.$store.commit('venueClosePopupOnceTime/SET_VENUE_CLOSE_POPUP_ONCE_TIME', nowTime)
  }

  getNextVenueOpenTime() {
    let res = t('next_opening_hours_not_set', 'Next opening hours: not set open time yet')
    const weekOrderList = [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday'
    ]
    if (this.weeklyOperatingHours) {
      // 现在关门，但是过一会儿就会开门
      const todayWeek = dayjs(this.currentVenueTime).format('dddd').toLowerCase()
      const todayOpenTime = this.weeklyOperatingHours[todayWeek]
      const isVenueCloseTime = !this.venueIsOpenTime
      if (isVenueCloseTime) {
        const unReachTodayOpenTime = checkReachTodayOpenTime(todayOpenTime.fromHour, this.currentVenueTime)
        if (todayOpenTime.enable && unReachTodayOpenTime && !todayOpenTime?.hourSettings?.length) {
          const fromTime = dayjs(`2019-01-25${todayOpenTime.fromHour}`).format('hh:mma')
          const toTime = dayjs(`2019-01-25${todayOpenTime.toHour}`).format('hh:mma')
          const week = _formatWeek(todayWeek)
          res = tParams('next_opening_hours_time', 'Next opening hours: {week} {fromTime} - {toTime}', { week, fromTime, toTime })
          this.nextVenueOpenTime = res
          return
        } else {
          res = tParams('next_opening_hours_time_range', 'Next opening hours: {time}', { time: _weeklyOperatingHours(this.weeklyOperatingHours) })
        }
      }

      const orderedWeekTimeList = _getOrderedWeekTimeList(weekOrderList, this.weeklyOperatingHours)
      const todayIndex = _getTodayIndex(weekOrderList, this.currentVenueTime)
      const lastList = orderedWeekTimeList.splice(0, todayIndex - 1)
      const orderedList = orderedWeekTimeList.concat(lastList)
      const venueNextOpenDayInfo = _filterOrderedList(orderedList, this.currentVenueTime)
      if (venueNextOpenDayInfo && !todayOpenTime?.hourSettings?.length) {
        const toTime = dayjs(`2019-01-25${venueNextOpenDayInfo.toHour}`).format('hh:mma')
        const fromTime = dayjs(`2019-01-25${venueNextOpenDayInfo.fromHour}`).format('hh:mma')
        const week = _formatWeek(venueNextOpenDayInfo.week)
        res = tParams('next_opening_hours_time', 'Next opening hours: {week} {fromTime} - {toTime}', { week, fromTime, toTime })
      } else {
        res = tParams('next_opening_hours_time_range', 'Next opening hours: {time}', { time: _weeklyOperatingHours(this.weeklyOperatingHours) })
      }
    }

    this.nextVenueOpenTime = res

    function checkReachTodayOpenTime(fromHour, currentVenueTime) {
      const [nowHour, nowMin] = dayjs(currentVenueTime).format('HH:mm').split(':')
      const [startHour, startMin] = fromHour.split(':')
      const reachHour = parseInt(nowHour) <= parseInt(startHour)
      const reachMin = parseInt(nowMin) <= parseInt(startMin)
      if (reachHour && reachHour) return true
    }

    function _filterOrderedList(orderedList, currentVenueTime) {
      const nowTime = dayjs(currentVenueTime).format('HH:mm')
      for (const [index, item] of orderedList.entries()) {
        if (item.enable && item.toHour && item.fromHour) {
          if (!index) {
            if (dayjs(`2021-10-10 ${nowTime}`).isSameOrBefore(`2021-10-10 ${item.toHour}`)) return item
          } else {
            return item
          }
        }
      }
    }

    function _getTodayIndex(weekOrderList, currentVenueTime) {
      const todayWeek = dayjs(currentVenueTime).format('dddd').toLowerCase()
      return weekOrderList.findIndex(item => item === todayWeek) + 1
    }

    function _getOrderedWeekTimeList(weekOrderList, weeklyOperatingHours) {
      return weekOrderList.map(item => {
        return {
          ...weeklyOperatingHours[item],
          week: item
        }
      })
    }
  }

  checkShowCloseTimeDialog() {
    const isVenueCloseTime = !this.venueIsOpenTime
    const isNotToday = this._checkIsNotToday()

    // 03-23 by 可乐
    // 当是外卖时，不考虑非营业时间情况
    // if (isVenueCloseTime) {
    if (isVenueCloseTime && !this.isOnline) {
      // if there is no venueId, the venueId doesn't exist.
      // disabled to showCloseTimeDialog
      if (!this.isReadOnly && isNotToday && this.venueId) this.showCloseTimeDialog = true // 如果今天出现过 pos 弹层，则不再弹出
    } else {
      this.$store.commit('venueClosePopupOnceTime/DEL_VENUE_CLOSE_POPUP_ONCE_TIME')
    }

    if (isVenueCloseTime && this.isOnline) {
      // 如果是非营业时间，只展示 'LATER'
      this.$refs.deliverInfoDialog.scheduledTime = 1
    }

    if (this.productGroups.length === 0 && this.venueIsOpenTime) {
      // send not available message
      const contentMessage = this.$store.state.venueHome.subGroupId
        ? 'The venue has paused online ordering for now. Please order at the counter or go back to select another venue.'
        : 'The venue has paused online ordering for now. Please order at the counter or ask staff for help.'
      MessageDialog.$create({
        $props: {
          icon: failIcon,
          content: contentMessage,
          buttonText: t('ok', 'OK')
        },
      }).show()
    }
  }

  // 显示 pos 提示弹窗
  checkShowClosePosDialog() {
    if (this.posStatus && this.posStatus.enable && this.posStatus.status !== 1) {
      if (this._checkIsPosPopup()) return
      let contentMessage = t('online_ordering_unavailable_counter', 'Online ordering is temporarily unavailable. Please order at the counter.')
      if (this.venueGroupId === '4df096df-8a68-4899-91ed-2dd43ab672c3') {
        // minor message
        contentMessage = t('online_ordering_unavailable_staff', 'Online ordering is temporarily unavailable. Please contact staff to order or try again later.')
      }
      MessageDialog.$create({
        $props: {
          icon: failIcon,
          content: contentMessage,
          buttonText: t('ok', 'OK')
        },
      }).show()
      const nowTime = dayjs(this.currentVenueTime).format('YYYY-MM-DD')
      this.$store.commit('venueClosePosPopup/SET_VENUE_CLOSE_POS_POPUP', nowTime)
    } else {
      this.$store.commit('venueClosePosPopup/DEL_VENUE_CLOSE_POS_POPUP')
    }
  }

  /**
   * 今天是否弹出过 pos 提示弹窗
   * @return {Boolean} 是否弹出过 pos 提示弹窗
   */
  _checkIsPosPopup() {
    const nowTime = dayjs(this.currentVenueTime).format('YYYY-MM-DD')
    const lastTime = this._getVenueClosePosPopup()
    return nowTime === lastTime
  }

  /**
   * 获取 pos 提示弹窗的弹出时间
   * @return {String} pos 提示弹窗的弹出时间
   */
  _getVenueClosePosPopup() {
    this.$store.commit('venueClosePosPopup/GET_VENUE_CLOSE_POS_POPUP')
    return this.$store.state.venueClosePosPopup.popupTime
  }

  _checkIsNotToday() {
    const nowTime = dayjs(this.currentVenueTime).format('YYYY-MM-DD')
    const lastTime = this._getVenueClosePopupOnceTime()
    return nowTime !== lastTime
  }

  _getVenueClosePopupOnceTime() {
    this.$store.commit('venueClosePopupOnceTime/GET_VENUE_CLOSE_POPUP_ONCE_TIME')
    return this.$store.state.venueClosePopupOnceTime.popupTime
  }

  async _filterAndSaveUnfinishOrder() {
    // filter and save unOverOrders
    if (this.userId) {
      await this._updateUnfinishOrders()
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  async _updateUnfinishOrders() {
    const orders = await this._getUserUnOverOrders('nostart_all')
    const ordersTotal = parseInt(orders.total)
    if (ordersTotal > 0) {
      const filtersOrder = orders.orders.filter(item => {
        if (item.paymentStatus === 0 && item.status <= 40) {
          return item
        }
      })
      if (filtersOrder.length > 0) {
        const order = filtersOrder[0]
        this._updateVenueUnpaidOrderList(order.id, order.orderNo)
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  _updateVenueUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  /**
   * 获取 user 下的 orders
   *  type 默认为 all
   *    close 为只展示已经完成的 order
   *    notstart 则为制作还未完成
   *    nostart_all 显示包括未付款且制作未完成的
   */
  async _getUserUnOverOrders(type) {
    const res = await getUserOrders({
      venueId: this.venueId,
      id: this.userId,
      type: type,
      pageSize: 5,
      pageNo: 1
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  // 根据订单 type 做出相应跳转
  _checkUnfinishOrder(order) {
    let hasUnfinishOrder
    const notOverOrderNo = order?.orderNo ?? ''
    const notOverOrderId = order?.id ?? ''
    const paymentStatus = order?.paymentStatus ?? ''
    const type = order?.type ?? ''
    const status = order?.status ?? ''
    // SP 模式下使用 /v/sp/ 路径前缀
    const venuePathPrefix = this.isSpMode ? `/v/sp/${this.venueId}` : `/v/${this.venueId}`

    const STATUS_ORDER_FINISH = 30
    const PAYMENT_TYPE = {
      POST_PAID_PAYMENTTYPE: 2,
      PRE_PAID_PAYMENTTYPE: 0
    }
    const PAYMENT_STATUS = {
      START: 0,
      SUCCESS: 1,
      FAILED: 2,
      PENDING: 3,
      REFUND: 4,
      REFUND_ERROR: 5
    }
    const isUrlTypeOrder = this._isUrlTypeOrder(order)
    // 若此订单不符合当前链接模式，停止继续运行
    if (!isUrlTypeOrder) return hasUnfinishOrder

    if (type === PAYMENT_TYPE.POST_PAID_PAYMENTTYPE) {
      // post-paid
      // 判断是否付款完成，完成则跳转到 my-order，未支付跳转到 pay
      if (paymentStatus === PAYMENT_STATUS.SUCCESS) {
        // 支付完成
        // 支付完成，且 order 完成
        if (status >= STATUS_ORDER_FINISH) {

        } else {
          // 支付完成，但 order 未完成
          // QR 扫码重定向不带 isMarketing，避免 campaign 重复显示
          this.$router.push({
            path: `${venuePathPrefix}/my-order/${notOverOrderId}`,
            query: {
              orderNo: notOverOrderNo,
            }
          })
        }
      } else {
        // 未支付
        // QR 扫码重定向不带 isMarketing，避免 campaign 重复显示
        this.$router.push({
          path: `${venuePathPrefix}/pay/${notOverOrderId}`,
          query: {
            orderNo: notOverOrderNo,
          }
        })
      }
    } else if (type === PAYMENT_TYPE.PRE_PAID_PAYMENTTYPE) {
      // pre-paid
      if (paymentStatus === PAYMENT_STATUS.SUCCESS) {
        // 支付完成 pre-paid
        // 支付完成，order 已完成
        if (status >= STATUS_ORDER_FINISH) {

        } else {
          // 支付完成，但是 order 未完成
          // QR 扫码重定向不带 isMarketing，避免 campaign 重复显示
          this.$router.push({
            path: `${venuePathPrefix}/my-order/${notOverOrderId}`,
            query: {
              orderNo: notOverOrderNo,
            }
          })
        }
      } else {
        // 支付未完成 pre-paid
      }
    } else if (type === PAYMENT_STATUS.REFUND) {
      // refund
    }
    return hasUnfinishOrder
  }

  /**
   * 判断订单是否符合 url 模式
   * @param {Object} order 订单信息
   * @returns {Boolean} 订单是否符合 url 模式
   */
  _isUrlTypeOrder(order) {
    let type = ''
    if (order) {
      const { details, menuType } = order
      // 根据订单信息，获取当前的订单类型
      if (details.orderType === 'dine-in' && details.table) type = 'table'
      else if (details.orderType === 'dine-in') type = 'counter'
      else if (details.orderType === 'takeaway' && menuType === 'normal') type = 'counter'
      else if (details.orderType === 'takeaway' && menuType === 'online') type = 'takeaway'
      else if (details.orderType === 'pickup') type = 'pickup'
      else if (details.orderType === 'delivery') type = 'delivery'
    }
    return this.urlType === type
  }

  tabsChange(name, title) {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    }
    )
  }

  _sendMsgToBacken() {
    // iframe 发送数据给父亲
    window.top.postMessage({
      name: 'mounted',
      data: 'mounted',
    }, '*')
  }

  // 获取 session 中的 activeIndex
  _getActiveIndex() {
    if (sessionStorage.getItem('activeIndex')) {
      const activeIndexList = JSON.parse(sessionStorage.getItem('activeIndex'))
      const venueActiveIndex = activeIndexList.filter(item => item.venueId === this.venueId)
      if (venueActiveIndex.length) {
        const activeIndex = parseInt(venueActiveIndex[0].activeIndex)
        if (validateActiveIndex(activeIndex, this.productGroups)) {
          this.activeIndex = activeIndex
        }
      }
    }

    function validateActiveIndex(activeIndex, productGroups) {
      return productGroups[activeIndex]
    }
  }

  // 获取 session 中的 _getScrollPosition。
  // 貌似是添加完购物车以后，重现加载当前页面，滚动到对应的商品列表
  _getScrollPosition() {
    let scrollPosition
    if (sessionStorage.getItem('activeIndex')) {
      const activeIndexList = JSON.parse(sessionStorage.getItem('activeIndex'))
      const venueActiveIndex = activeIndexList.filter(item => item.venueId === this.venueId)
      if (venueActiveIndex.length) {
        scrollPosition = parseInt(venueActiveIndex[0].scrollPosition)
      }
    } else {
      scrollPosition = 0
    }
    setTimeout(() => {
      window.scrollTo(0, scrollPosition)
      document.documentElement.scrollTop = scrollPosition
    }, 500)
  }

  // 设置 showMask 在 venue 会查找 show
  showMask() {
    const mark = localStorage.getItem('showMask')
    this.showOrderHistoryDialog = mark === 'show'
  }

  // 如果有 number，保存 type。关键是没有 number，直接重置 number，以保证 number 的绝对效力。!important
  saveData() {
    if (this.number) {
      this.$store.commit('saveRouterInfo', {
        prop: 'type',
        val: 't'
      })
      this.$store.commit('saveRouterInfo', {
        prop: 'number',
        val: safeDecodeURI(this.number)
      })

      this.$store.commit('saveRouterInfo', { // 添加唯一标识
        prop: 'noTable',
        val: false
      })
    } else {
      // 判断是否不带桌号进入
      this.$store.commit('saveRouterInfo', { // 添加唯一标识
        prop: 'noTable',
        val: this.$route.path === `/v/${this.venueId}/t`
      })

      this.$store.commit('saveRouterInfo', {
        prop: 'type',
        val: 'p'
      })
      this.$store.commit('saveRouterInfo', {
        prop: 'number',
        val: ''
      })
    }
    this.$store.commit('saveVenueId', this.venueId)
  }

  // 对 productList 进行 map，结构重构
  listComputed(productList) {
    let sortProductList = productList.filter(item => item && item.id !== this.freeItemId)
    // noAlcohol 开启时,从菜单隐藏含酒精商品(整组皆酒精时 tab 也随 length===0 隐藏)
    // 注意:app.js 经 ...app 铺在根 state,故读 state.noAlcohol 而非 state.app.noAlcohol
    if (this.$store.state.noAlcohol) {
      sortProductList = sortProductList.filter(item => !isAlcoholProduct(item))
    }
    sortProductList = sortProductList.sort((a, b) => a.order - b.order)
    return sortProductList.map(item => {
      const id = item.id
      const currentproduct = this.proList.filter(child => child.id === id)
      if (currentproduct.length) {
        return {
          ...item,
          num: currentproduct.reduce((total, prev) => total + prev.num, 0),
        }
      } else {
        return item
      }
    })
  }

  // 获取 menu 接口，返回值是控制 menu 显示的数据
  // 多版本菜单 B6：带 context{creatorType:'qr', orderType?, table?} 请后端按条件解析菜单，存下 resolvedMenu.menuId；
  // 合单（D98①）不带 context、menuId 留空 —— 与今天一样只带 venueId。不给 get-menu 带 menuId。
  // 多版本菜单 N35-B2：随 context 送这一次光顾扫的码（桌码 / 柜台码；Custom Flows 与非堂食不送；通用桌码不带顾客自己填的桌号，Q17）。
  // 这一次光顾的码写在地址上（进店参数 mmEntry，`qrEntry.js`，review 第 4 轮起零存储）：扫码进店那一刻路由守卫按入口地址写进去，
  // 站内跳转一路补过来；这里只读当前地址，不按首页此刻的路由名 / portal 猜（柜台顾客填了桌号回菜单是 /home/t/7?portal=true）。
  // 地址上没有 ⇒ 不送（fail closed）。多版本菜单 N35-B5：地址里的点单链接码 menuLink 一起现读、送出（`menuLink.js`，不存）。
  // 各页下单读同一个（`menuEntry`），不经 store。
  async _getMenu() {
    const where = {
      venueId: this.venueId,
      query: this.$route.query,
      table: this.number,
      takeawayAllowed: this.dineInSettings?.enableTakeaway !== false
    }
    const entry = menuEntry(this.$store.state, this.$route)
    const context = menuContextFromState(this.$store.state, { ...where, ...entry })
    const params = { venueId: this.venueId }
    if (context) params.context = context
    const res = await getMenu(params).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    // 老后端没回 resolvedMenu ⇒ ''，之后 get-product-list / 商品页 / 下单都照今天不带 menuId
    const menuId = context ? resolvedMenuIdOf(res) : ''
    // 迟到的响应（这期间顾客已经进了别家店）不许把这家店的菜单装进别家店（U-B6-1 review，Codex）
    if (isStoreVenue(this.$store.state, this.venueId)) this.$store.commit('saveMenuId', menuId)
    return { productGroups: res.productGroups, menuId }
  }

  // 获取 venue 的信息，并保存到 vuex
  async _postVenue() {
    // 「保存到桌面」开关先归零：vuex 值会被 vuex-persist 持久化，上一家店的
    // true 不清掉的话，加载窗口内（或本次加载失败后整个会话）抽屉都会显示
    // 一个点了没反应的入口——数据落地前一律隐藏
    this.$store.commit('saveEnableAddToHomeScreen', false)
    try {
      // SP 模式下添加 spMode 参数，以获取 spTableList
      const venueParams = {
        id: safeDecodeURI(this.$route.params.venueId)
      }
      if (this.isSpMode) {
        venueParams.spMode = true
      }
      const venueInfo = await getVenue(venueParams)
      this.logo = venueInfo.logo
      const venueName = venueInfo.name
      this.venueName = venueInfo.name
      const paymentType = venueInfo.settings.options.paymentType
      const orderType = venueInfo.settings.options.takeaway
      const country = venueInfo.country
      this.savePaymentType(paymentType)
      this.saveOrderType(orderType)
      this.saveVenueName(venueName)
      this._saveVenueCheckinInfo({
        banner: venueInfo.logo,
        logo: venueInfo.secLogo || venueInfo.logo,
        name: venueInfo.name
      })
      this._saveOnlineDisabledButton(venueInfo.settings)
      this.venueOperationTime = venueInfo.todayOperatingHours
      this.venueId = venueInfo.id
      this.weeklyOperatingHours = venueInfo.settings.weeklyOperatingHours
      this.weeklyOperatingHoursSegmentation = venueInfo.settings.weeklyOperatingHours
      this.enableCheckin = venueInfo.settings.checkInSettings?.enableCheckin
      this.checkinJumpToUrl = venueInfo.settings.checkInSettings?.checkInUrl
      this.posStatus = venueInfo.settings.posStatus
      this.customMessageSettings = venueInfo.settings?.customMessageSettings ?? {}
      this.spModeSettings = venueInfo.settings?.spModeSettings ?? {}

      // SP 模式检查：如果当前是 SP 模式但 spModeSettings 未启用，则重定向到普通模式
      if (this.isSpMode && !this.spModeSettings?.enableSpMode) {
        const normalPath = this.$route.path.replace('/v/sp/', '/v/')
        this.$router.replace(normalPath + window.location.search)
        return
      }

      // SP 模式下保存 spTableList
      if (this.isSpMode && this.spModeSettings?.enableSpMode) {
        this.spTableList = venueInfo.spTableList ?? []
      }

      const dineInSettings = venueInfo.settings?.dineInSettings ?? {}
      // 若 dineInSettings - viewOnlyMessage 没有值，给 viewOnlyMessage 赋值默认值
      if (!dineInSettings?.viewOnlyMessage) {
        dineInSettings.viewOnlyMessage = {
          title: t('preview_menu_title', 'Preview our menu before you arrive.'),
          content: t('preview_menu_content', 'To place an order, scan one of our QR codes at the airport.'),
        }
      }
      this.dineInSettings = dineInSettings

      // 保存 force input table 信息
      if (venueInfo.settings && venueInfo.settings.options && venueInfo.settings.options.forceTableInput) {
        this.$store.commit('saveForceTable', true)
      } else {
        this.$store.commit('saveForceTable', false)
      }

      // 「保存到桌面」按店开关；同步进 vuex 供 App.vue 层的抽屉菜单入口使用
      this.enableAddToHomeScreen = !!(venueInfo.settings && venueInfo.settings.options && venueInfo.settings.options.enableAddToHomeScreen)
      this.$store.commit('saveEnableAddToHomeScreen', this.enableAddToHomeScreen)
      this.homeScreenName = typeof venueInfo.homeScreenName === 'string' ? venueInfo.homeScreenName : ''
      // iOS 书签图标/名字注入放这里而非弹窗组件：顾客可能从 dine-in 页、cart 页
      // 自己走分享菜单保存，弹窗组件在那些页面根本不挂载。工具内部只在
      // iOS Safari 生效；flag 关的店不注入（尊重运营关停开关）
      if (this.enableAddToHomeScreen) {
        applyIosBookmarkMeta({
          venueId: this.venueId,
          venueName: this.venueName,
          homeScreenName: this.homeScreenName
        })
      }
    } catch (error) {
      this.$store.commit('closeLoading')
      console.log(error)
    }
  }

  _saveOnlineDisabledButton(venueInfo) {
    const offDelivery = this._isOffDelivery(venueInfo?.deliverySettings?.pauseSetting)
    const enablePickup = venueInfo?.pickupSettings?.enableTakeaway ?? venueInfo?.options?.takeaway ?? false
    const enableDelivery = venueInfo?.deliverySettings?.enableDelivery ?? false
    const onlineDisabledButton = this.isOnline && !enablePickup && enableDelivery && offDelivery
    this.$store.commit('saveOnlineDisabledButton', onlineDisabledButton)
  }

  /**
   * @param pauseSetting {Object} 餐厅设置，delivery - pauseSetting
   * @returns {Boolean} 餐厅是否已关闭 delivery
   */
  _isOffDelivery(pauseSetting) {
    const nowTime = dayjs(this.currentVenueTime).format('YYYY-MM-DD HH:mm:ss')
    const startTime = pauseSetting?.startTime ?? ''
    const endTime = pauseSetting?.endTime ?? ''
    if (nowTime === startTime ||
        nowTime === endTime ||
        dayjs(nowTime).isBetween(startTime, endTime, 's')
    ) return pauseSetting?.enable ?? false
    return false
  }

  _saveVenueCheckinInfo(venueCheckInfo) {
    this.$store.commit('saveCheckinInfo', venueCheckInfo)
  }

  saveVenueName(venueName) {
    this.$store.commit('saveNavTitle', {
      prop: 'venueName',
      val: venueName
    })
  }

  savePaymentType(paymentType) {
    this.$store.commit('saveRouterInfo', {
      prop: 'paymentType',
      val: paymentType || this.defaultPaymentType
    })
  }

  saveOrderType(orderType) {
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    this._setUrlType()
    // console.log(this.urlType)
    if (this.urlType === 'table' || this.urlType === '') {
      orderType = false
    } else if (this.urlType === 'counter') {
      orderType = false
    }
    if (isTakeaway) {
      orderType = true
    }
    if (orderType === false) {
      this.$store.commit('addDetailsProp', {
        prop: 'orderType',
        val: 'dine-in'
      })
    } else if (orderType === true) {
      this.$store.commit('addDetailsProp', {
        prop: 'orderType',
        val: 'takeaway'
      })
    }
  }

  // 获取 productList
  // 多版本菜单 B6：get-product-list 与 get-menu 按分类 id 配对，必须是同一份菜单 —— menuId 直接用刚才 get-menu 解析出的那个
  // rethrowMenuGone：只有 getData 的第一次读才把「菜单不在用」交出去成对重来；重来那次照改动前一样吞掉（返回 undefined）
  async _postProduct(menuId, rethrowMenuGone = false) {
    try {
      const requestData = {
        venueId: this.venueId
      }

      const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
      // 若是外卖系统，并且是预定单，将预定日期传递给接口
      if (this.isOnline && deliveryInfo.preOrderTimeSettings) requestData.preOrderDate = dayjs(deliveryInfo.preOrderTimeSettings).format('YYYY-MM-DD')

      const res = await getProductList(withMenuId(requestData, menuId))
      return res.productGroup
    } catch (error) {
      console.log(error)
      // 这份菜单已不在用（get-menu 与 get-product-list 之间被归档 / 下线）：交给 getData 成对重来一次 —— 加载圈留着，重来那次结束再关
      if (rethrowMenuGone && isMenuGoneError(error)) throw error
      this.$store.commit('closeLoading')
    }
  }

  _getTime() {
    const week = dayjs(this.currentVenueTime).format('dddd').toLowerCase()
    const hour = parseInt(dayjs(this.currentVenueTime).format('HH'))
    const minute = parseInt(dayjs(this.currentVenueTime).format('mm'))
    this.time = {
      week,
      hour,
      minute
    }
  }

  _validateIsOpenTime() {
    let res = false
    const { hour, minute } = this.time
    const venueOperationTime = this.venueOperationTime

    // 兼容 venueOperationTime 为 null 的情况
    if (!venueOperationTime) return res

    if (venueOperationTime.enable) {
      try {
        res = !!_getNowOperatingHours(venueOperationTime)
      } catch (error) {
        console.log(error)
      }
    }
    this.isOriginalVenueOpenTime = res
    this.venueIsOpenTime = res || this.isOnline
    return res || this.isOnline
  }

  /**
   * 更新一个符合要求的新对象，改变之后结构相同，hourSettings 存在就取 hourSettings 中的数据
   * @param data {Object} 要改变的餐厅营业时间
   * @returns {Object} 更新之后的餐厅营业时间
   */
  _setWeeklyOperatingHoursSegmentation(data) {
    const newData = {}
    for (const item in data) {
      newData[item] = {
        ...this._setHourSettings(data[item])
      }
    }
    return newData
  }

  /**
   * 筛选一个符合要求的新对象
   * @param data {Object} 要筛选的餐厅营业时间
   * @returns {Object} 筛选之后的餐厅营业时间
   */
  _setHourSettings(data) {
    if (data.hourSettings?.length > 0) {
      return {
        enable: data.enable,
        fromHour: data.hourSettings[0].fromHour,
        toHour: data.hourSettings[0].toHour,
      }
    } else {
      return data
    }
  }

  // 控制 productGroups 的显示
  controlMenu(menu, productGroups) {
    let productList = []
    productGroups.map((item) => {
      menu.forEach(each => {
        // console.log(each.name, this._isPreMenu(each))
        if (this.isOnline && !this._isPreMenu(each)) return
        if (item.id === each.id) {
          const status = each.status
          const courseNumber = each.details ? each.details.courseNumber : ''
          const categoryIsOpen = _isOpenStatus(each.operatingHours, 'sameAsVenue', this.venueIsOpenTime)
          if (status && categoryIsOpen) {
            if (status === 1) {
              productList.push({
                ...item,
                details: each.details,
                disabled: false,
                orderNo: each.orderNo,
                productGroupCourse: courseNumber
              })
            } else if (status === 2) {
              productList.push({
                ...item,
                details: each.details,
                disabled: true,
                orderNo: each.orderNo,
                productGroupCourse: courseNumber
              })
            }
          }
        }
      })
    })
    productList = this.controlProducts(productList)
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    if (this.isOnline || isTakeaway) productList = this._filterDeliveryProduct(productList)
    const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
    if (this.isOnline && deliveryInfo.preOrderTimeSettings) productList = this._filterPreOrderStockProduct(productList)
    // 过滤掉无可用商品的分类，然后再做分类排序
    this.productGroups = productList.filter(item => {
      const products = item?.products ?? []
      // noAlcohol 时:整组全是酒精则隐藏(需至少一个非酒精的在售商品);noAlcohol 在根 state
      if (this.$store.state.noAlcohol) return products.some(product => product.status && !isAlcoholProduct(product))
      return products.find(product => product.status)
    }).sort((a, b) => a.orderNo - b.orderNo)
  }

  controlProducts(list) {
    return list.map(item => {
      let productList = item.products
      if (productList && productList.length) {
        // SP 模式下，过滤掉未启用 enableSpMode 的商品
        if (this.isSpMode) {
          productList = productList.filter(product => product.enableSpMode !== false)
        }
        // 不展示必选商品都不可选的套餐商品
        productList = productList.filter(product => {
          // 必选配菜组里一样都选不了的商品：**不展示**（owner 2026-08-10 裁定）。
          // 判据与商品详情页那道门是同一个函数，见
          // product-detail/utils/productDisplay.js。这种商品顾客点进去也加不进
          // 购物车 —— 那一组要他「至少选 1 样」，而那一组里一样都没有。
          // 摆在菜单上只会让人白点一次。
          if (productHasUnpickableRequiredSection(product)) return false
          // 商品是套餐时
          if (product.type === 'combo') {
            const requiredComboList = product.comboProducts?.filter(item => item.type === 'oneProduct') ?? []
            // 若套餐有必选商品
            if (requiredComboList.length) {
              // 判断套餐的必选商品是不是全不可选
              // TODO: need to change check all products are not available
              return !requiredComboList.every(requiredCombo => requiredCombo.products.every(product => {
                const { hide, status, allowDelivery, operatingHours } = product.detail ?? {}
                const isOnline = this.isOnline || this.$route.path.includes('/o/')
                return hide || !status || (isOnline && !allowDelivery) || !_isOpenStatus(operatingHours, 'sameAsProductGroup', this.venueIsOpenTime)
              }))
            }
            // 若套餐没有必选商品，use it
            return true // always true
          }
          return true
        })
        // 分类下的每个商品，添加分类相关的数据
        productList = productList.map(product => ({
          ...product,
          productGroupId: item.id,
          productGroupCourse: item.productGroupCourse
        }))
        return {
          ...item,
          products: productList.filter(products => !products?.hide && _isOpenStatus(products.operatingHours, 'sameAsProductGroup', this.venueIsOpenTime))
        }
      }
      return item
    })
  }

  // 获取数据
  // 多版本菜单 B6：get-product-list 回「Can not found menu.」⇒ 清掉 menuId，get-menu（带 context）+ get-product-list 成对重来一次，
  // 不弹窗；重来之后还是不在用就与其它 get-product-list 失败一样吞掉（返回 undefined 交给 controlMenu，不循环）——
  // 不能交出去：mounted 里 `await this.getData()` 之后的步骤会整段跳过（B6 U-B6-1 验收 P2）
  async getData() {
    let firstRead = true
    const loadMenuPair = async () => {
      const rethrowMenuGone = firstRead
      firstRead = false
      const { productGroups, menuId } = await this._getMenu()
      const menu = this._filterMenu(productGroups)
      this._validateIsOpenTime()
      const productGroup = await this._postProduct(menuId, rethrowMenuGone)
      return { menu, productGroup, menuId }
    }
    const { menu, productGroup, menuId } = await readWithMenuRetry(loadMenuPair, () => this.$store.commit('saveMenuId', ''))
    // get-product-list 失败（含重来之后仍不在用）⇒ 不交给 controlMenu：它对 undefined 直接 .map 抛错，mounted 后面的步骤会整段跳过
    if (productGroup === undefined) return
    this.controlMenu(menu, productGroup)
    // 多版本菜单 B6（D97，U-B6-2）：这次解析出的菜单与建车菜单不同、车里有这家店的行 ⇒ 按手上这份商品表本地核对：
    // 不在上面的行标出来（购物车页显示成删除态）、提示一句，建车菜单记成这份菜单；不清车。同一份菜单 / 老后端 / 合单什么都不做。
    // 菜单预览地址不做（review 第 2 轮 G6）：这份是还没上线的草稿，拿它标真购物车（会存进 localStorage）、提示「菜单刚更新」、记建车菜单都不对
    if (isOrderingBlockedByPreview(this.$route)) return
    checkCartAgainstMenu(this.$store, { menuId, productGroups: productGroup, notify: () => createMessageDialog(menuChangedNoticeText()) })
  }

  // 填写 delivery 信息后，重新获取商品
  async deliveryGetData() {
    this.$store.commit('showLoading')
    await this.getData()
    this.$store.commit('closeLoading')
    this._setAllergyDialog()
  }

  redirectUpgradeCombo(data) {
    const { id, productGroupId, productGroupCourse } = data
    this.jumpToMenu(id, productGroupId, productGroupCourse, data)
  }

  /**
   * 跳转到 product details 页面
   * @param {String} productId 商品的 id
   * @param {String} productGroupId 商品的所属分类 id
   * @param {String} productGroupCourse 商品的所属分类路线
   * @param {Object} item
   */
  jumpToMenu(productId, productGroupId, productGroupCourse, item) {
    if (this.disabledButton) return

    if (item) {
      let upgradeProduct = null
      // 若 upgradeComboProducts 有值,则取值
      if (item.upgradeComboProducts && item.upgradeComboProducts[0]) {
        upgradeProduct = item.upgradeComboProducts
      }

      // 若 upgradeComboProducts 无值,则取 upgradeProducts 值
      if (!upgradeProduct && item.upgradeProducts && item.upgradeProducts[0]) {
        upgradeProduct = item.upgradeProducts
      }

      if (upgradeProduct) {
        const upgradeProductItem = upgradeProduct[0].items[0]
        const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
        let isPass = upgradeProductItem.status && _isOpenStatus(upgradeProductItem.operatingHours, 'sameAsProductGroup', this.venueIsOpenTime)

        if (isPass && this.isOnline && deliveryInfo.preOrderTimeSettings) {
          isPass = upgradeProductItem.allowDelivery
        }

        if (isPass && this.isOnline && deliveryInfo.preOrderTimeSettings && upgradeProductItem.type === 'combo') {
          if (upgradeProductItem?.comboProducts?.length) { // 套餐中存在商品
            // requiredCommodityList，将套餐中的必选商品，筛选到此变量
            const requiredCommodityList = upgradeProductItem.comboProducts.filter(item => item.type === 'oneProduct')
            // 若不存在必选商品，返回 false
            if (!requiredCommodityList?.length) isPass = false
            // 判断必选商品中是否全都有库存。若全部商品没有库存，就隐藏该套餐
            isPass = !requiredCommodityList.every(requiredCommodity => requiredCommodity?.products?.every(product => !this._checkStockProduct(product?.detail)))
          } else {
            isPass = false
          }
        }

        if (isPass) {
          this.upgradeProduct = upgradeProduct
          this.selectProductIdInfo = { id: productId, productGroupId: productGroupId, productGroupCourse: productGroupCourse, price: item.price, sizeSettings: item.sizeSettings }
          this.showUpgradeComboDialog = true
          return
        }
      }
    }

    const h = document.getElementsByClassName('van-tab')[0].offsetHeight ?? 0
    // save scroll bar height
    const scrollPosition = (document.documentElement.scrollTop || window.pageYOffset) - h
    // save activeIndex
    const activeIndexInfo = {
      venueId: this.venueId,
      activeIndex: this.activeIndex,
      scrollPosition
    }

    if (sessionStorage.getItem('activeIndex')) {
      const activeIndexList = JSON.parse(sessionStorage.getItem('activeIndex'))
      const venueActiveIndex = activeIndexList.filter(item => item.venueId === this.venueId)
      if (venueActiveIndex.length) {
        const index = activeIndexList.findIndex(item => item.venueId === this.venueId)
        venueActiveIndex[0].activeIndex = this.activeIndex
        venueActiveIndex[0].scrollPosition = scrollPosition
        sessionStorage.setItem('activeIndex', JSON.stringify(activeIndexList))
      } else {
        activeIndexList.push(activeIndexInfo)
        sessionStorage.setItem('activeIndex', JSON.stringify(activeIndexList))
      }
    } else {
      sessionStorage.setItem('activeIndex', JSON.stringify([activeIndexInfo]))
    }

    if (this.$openreplayTracker) this.$openreplayTracker.event('view_item')
    if (this.$gtag) {
      this.$gtag.event('view_item', {
        event_category: 'purchase_journey',
        event_label: 'View Product',
      })
    }

    const query = {
      productGroupId,
      productGroupCourse
    }
    if (item.fromProductId) query.fromProductId = item.fromProductId

    if (this.number) {
      this.$router.push({
        path: `/v/${this.venueId}/product/t/${this.number}/${productId}`,
        query: query
      })
    } else {
      this.$router.push({
        path: `/v/${this.venueId}/product/p/${productId}`,
        query: query
      })
    }
  }

  // 跳转到 cart 页面
  jumpToCart() {
    const urlPart = this.$store.state.venueHome.subGroupId && this.$store.state.venueHome.subGroupId.length > 0 ? `vgs/${this.$store.state.venueHome.subGroupId}` : `v/${this.venueId}`
    if (this.number) {
      this.$router.push(`/${urlPart}/cart/t/${this.number}`)
    } else {
      this.$router.push(`/${urlPart}/cart/p`)
    }
  }

  // 根据用户的系统，筛选 menu
  _filterMenu(menu) {
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    const menuType = (this.isOnline || isTakeaway) ? 'online' : 'normal'
    this.$store.commit('saveMenuType', menuType)
    return menu.filter(item => {
      // 若 productGroup 开启 enableTestMode，并且 URL 中没有 'enableTestMode=true'，则隐藏分组
      if (item.details?.enableTestMode && this.$route?.query?.enableTestMode !== 'true') return false
      // SP 模式下，过滤掉未启用 enableSpMode 的分类
      if (this.isSpMode && item.details?.enableSpMode === false) return false
      return ((this.isOnline || isTakeaway) ? item.details?.enableOnline : item.details?.enableDinein) ?? true
    })
  }

  // 筛选 Delivery 商品
  _filterDeliveryProduct(list) {
    // 筛选商品
    let productList = list.map(productGroup => ({
      ...productGroup,
      products: productGroup.products.filter(product => product.allowDelivery)
    }))

    // 筛选推荐菜
    productList = productList.map(productGroup => ({
      ...productGroup,
      products: productGroup.products.map(product => ({
        ...product,
        recommendationProducts: product.recommendationProducts.map(recommendation => ({
          ...recommendation,
          // allowOnline 是分类级模式旗（后端 2026-08-27 起下发，缺键 = 放行）：
          // 商品所有分类都关了 enableOnline 时，online/takeaway 环境不展示它
          items: recommendation.items.filter(item => item.allowDelivery && item.allowOnline !== false)
        }))
      }))
    }))

    return productList
  }

  /**
   * 筛选预定单的库存商品
   * @param productList {Array} 商品列表
   * @returns {Array} 筛选过的库存商品列表
   */
  _filterPreOrderStockProduct(productList) {
    const list = productList.map(item => {
      return {
        ...item,
        products: item.products.filter(product => {
          if (product.type === 'combo') { // 商品类型是套餐
            if (product?.comboProducts?.length) { // 套餐中存在商品
              // requiredCommodityList，将套餐中的必选商品，筛选到此变量
              const requiredCommodityList = product.comboProducts.filter(item => item.type === 'oneProduct')
              // 若不存在必选商品，返回 false
              if (!requiredCommodityList?.length) return false
              // 判断必选商品中是否全都有库存。若全部商品没有库存，就隐藏该套餐
              return !requiredCommodityList.every(requiredCommodity => requiredCommodity?.products?.every(product => !this._checkStockProduct(product?.detail)))
            }
            return false
          }
          return true
        })
      }
    })

    return list
  }

  /**
   * 校验商品库存
   * @param product {Array} 校验的商品信息
   * @returns {Boolean} 是否有商品库存
   */
  _checkStockProduct(product) {
    const stockSettings = product?.stockSettings
    // 判断商品是否设置库存
    if (stockSettings?.enableStockCount) {
      // 今日当前剩余库存数量
      const currentStockCount = Number(stockSettings?.currentStockCount ?? 0)
      // 过滤没有剩余数量的商品
      return currentStockCount > 0
    }
    return true
  }

  // 查看所有开放时间
  onSeeAllOpeningHours(showSeeAllOpeningHours) {
    this.$refs[showSeeAllOpeningHours].onOverlany()
  }

  /**
   * 商品分类是否满足预订单时间
   * @param menu {Object} 分类信息
   */
  _isPreMenu(menu) {
    const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
    const { operatingHours } = menu
    let res = operatingHours.type === 'sameAsVenue'
    if (operatingHours.type === 'custom') {
      const selectTime = deliveryInfo.preOrderTimeSettings ? deliveryInfo.preOrderTimeSettings : dayjs(this.currentVenueTime)

      const week = dayjs(selectTime).format('dddd').toLowerCase()
      const hour = Number(dayjs(selectTime).format('H'))
      const minute = Number(dayjs(selectTime).format('m'))
      res = _isPassCustomHours(operatingHours, week, hour, minute)
    }
    return res
  }

  // 解析 noAlcohol 是否开启:URL 的 noAlcohol=1 / filterRule=noAlcohol,或当前子分组的 subGroupSettings.noAlcohol
  _resolveNoAlcohol() {
    const q = this.$route.query
    const filterRule = typeof q.filterRule === 'string' ? q.filterRule.split(',').map(s => s.trim()) : []
    const fromUrl = q.noAlcohol === '1' || filterRule.includes('noAlcohol')
    const subGroupId = this.$store.state.venueHome.subGroupId
    const fromSubgroup = !!(subGroupId && this.$store.state.venueHome.subGroupSettings?.[subGroupId]?.noAlcohol)
    return fromUrl || fromSubgroup
  }

  _setupSubGroup() {
    const subGroupId = this.$route.query.subGroupId ?? null
    // console.log('check sub:' + subGroupId)
    if (subGroupId) {
      this.$store.commit('saveSubGroupId', subGroupId)
    } else if (this.fromQR || isOrderingBlockedByPreview(this.$route)) {
      // access portal from normal venue
      // 多版本菜单 B6（U-B6-2 review 第 2 轮 G5）：管理端的菜单预览链接（/v/<id>/p?previewMenu=…）也是单店入口、却没有 ?qr=1 ——
      // 上一次走合单进过这家店留下的 subGroupId 不清的话，读菜单当成合单（不带预览头），预览页看到的是主菜单。合单购物车不碰
      this.$store.commit('saveSubGroupId', null)
    }
  }
}

export default VenueIndex
</script>
